import React from 'react';
import { useUser } from '@clerk/clerk-react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SessionLostNotice, useSupabaseSessionLost } from './SessionLostNotice';

export const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isSignedIn, isLoaded } = useUser();
  const { t } = useTranslation();
  const sessionLost = useSupabaseSessionLost();

  if (!isLoaded) {
    return (
      <div className="min-h-screen max-w-lg mx-auto bg-[#f8fafc] flex flex-col items-center justify-center text-center p-8">
        <Loader2 className="animate-spin text-emerald-500" size={48} />
        <h1 className="text-xl font-bold mt-4">{t('app.loading_app')}</h1>
      </div>
    );
  }

  // A session Clerk dropped locally isn't a sign-out: offer to restore it
  // instead of leaving the page (and any unsaved work on it).
  if (sessionLost) {
    return <SessionLostNotice />;
  }

  if (!isSignedIn) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
